import {repoId as baikeRepoId} from '../const';

export const getIsBaikeRepo = (repoId: string) => {
    return repoId === baikeRepoId;
};
